import { lazy } from "react"

export const Routes = [
  {
    path: "/login",
    component: lazy(() => import("../views/auth/Login")),
    layout: "BlankLayout",
    meta: {
      authRoute: true
    }
  },
  // {
  //   path: "/privacy",
  //   component: lazy(() => import("../views/privacy")),
  //   layout: "BlankLayout",
  //   meta: {
  //     publicRoute:true
  //   }
  // },
  // {
  //   path: "/support",
  //   component: lazy(() => import("../views/support")),
  //   layout: "BlankLayout",
  //   meta: {
  //     publicRoute:true
  //   }
  // },
  {
    path: "/admin/list",
    component: lazy(() => import("../views/admin-list")),
    meta: {
      action: "call",
      resource: "NoPermissionCode"
    }
  }
]
